export default __webpack_public_path__ + "9bce481d0405f7b10c8ab7d0a479fea8.png";